export const REPEAT_LINKAGE_OPTIONS = Array.from({ length: 12 }, (_, index) => index + 1)

const padDatePart = value => String(value).padStart(2, '0')

export const addMonthsToLinkageDate = (dateValue, monthsToAdd) => {
  const match = String(dateValue ?? '').match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!match) return dateValue

  const year = Number(match[1])
  const monthIndex = Number(match[2]) - 1
  const day = Number(match[3])
  const targetMonthStart = new Date(Date.UTC(year, monthIndex + monthsToAdd, 1))
  const lastDayOfTargetMonth = new Date(
    Date.UTC(targetMonthStart.getUTCFullYear(), targetMonthStart.getUTCMonth() + 1, 0)
  ).getUTCDate()

  return [
    targetMonthStart.getUTCFullYear(),
    padDatePart(targetMonthStart.getUTCMonth() + 1),
    padDatePart(Math.min(day, lastDayOfTargetMonth))
  ].join('-')
}

export const createRepeatedLinkages = async ({
  payload,
  repetitions = 1,
  createLinkage
}) => {
  const total = Math.min(12, Math.max(1, Number(repetitions) || 1))
  const payloads = Array.from({ length: total }, (_, index) => ({
    ...payload,
    fecha: addMonthsToLinkageDate(payload.fecha, index)
  }))

  return Promise.all(payloads.map(createLinkage))
}
